import { RefObject, useCallback, useRef, useState } from 'react'

import { DEFAULT_PX_PER_MINUTE, TIMELINE_SCALE_STEPS, TimelineScaleStep } from '../constants'

export const useTimelineScale = (scrollRef: RefObject<HTMLDivElement>) => {
  const [pxPerMinute, setPxPerMinute] = useState<TimelineScaleStep>(DEFAULT_PX_PER_MINUTE)
  // ブラウザによる scrollTop の自動クランプより前の値を保持しておく
  const scrollTopBeforeScaleRef = useRef<number | null>(null)

  const canIncrement = pxPerMinute < TIMELINE_SCALE_STEPS[TIMELINE_SCALE_STEPS.length - 1]
  const canDecrement = pxPerMinute > TIMELINE_SCALE_STEPS[0]

  const captureScrollTop = useCallback(() => {
    if (scrollRef.current) {
      scrollTopBeforeScaleRef.current = scrollRef.current.scrollTop
    }
  }, [scrollRef])

  const increment = useCallback(() => {
    captureScrollTop()
    setPxPerMinute((prev) => {
      const idx = TIMELINE_SCALE_STEPS.indexOf(prev)
      return TIMELINE_SCALE_STEPS[Math.min(idx + 1, TIMELINE_SCALE_STEPS.length - 1)]
    })
  }, [captureScrollTop])

  const decrement = useCallback(() => {
    captureScrollTop()
    setPxPerMinute((prev) => {
      const idx = TIMELINE_SCALE_STEPS.indexOf(prev)
      return TIMELINE_SCALE_STEPS[Math.max(idx - 1, 0)]
    })
  }, [captureScrollTop])

  return {
    pxPerMinute,
    canIncrement,
    canDecrement,
    increment,
    decrement,
    scrollTopBeforeScaleRef,
  }
}
